import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import find from 'lodash/find';
import get from 'lodash/get';

// Absolute Imports
import Button from 'yoda-core-components/lib/components/Button';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import {
    PAYMENT_METHOD_CREDIT_CARD,
    CREATE_ACCOUNT_MESSAGE_CATEGOR_ERROR,
    CREATE_ACCOUNT_MESSAGE_CATEGOR_SUCCESS,
    LEARN_MORE,
    BNPL_SYF,
} from 'yoda-checkout-components/lib/common/Constants';
import { enableInputFieldMaskFix } from 'yoda-account-components/lib/common/Constants';
import {
    OC_ACCOUNT_CREATION_NOTE,
    CONTINUE_SHOPPING,
    CREATE_ACCOUNT,
    CREATE_ACCOUNT_SUCCESS_MESSAGE,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import PhoneInputField from 'yoda-checkout-components/lib/components/CustomTags/PhoneInputField/PhoneInputField';
import CreatePasswordInputField from 'yoda-checkout-components/lib/components/CustomTags/CreatePasswordInputField/CreatePasswordInputField';
import IconTooltip from 'yoda-account-components/lib/components/IconTooltip/IconTooltip';
import Information from 'yoda-core-components/lib/assets/svg/Information.svg';
import * as showGlobalLoaderAction from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ChooseYourReward from 'yoda-account-components/lib/components/ChooseYourReward/ChooseYourReward';
import MarketingOptin from 'yoda-account-components/lib/components/CreateAccount/MarketingOptin';
import CreateAccountMessage from '../CreateAccountMessage/CreateAccountMessage';
import OptinForExpressCheckout from '../../containers/Pages/OrderConfirmation/components/OptinForExpressCheckout/OptinForExpressCheckout';
import * as actions from '../../actions/CreateAccountPostOrderAction';
import * as styles from './CreateAccountPostOrder.css';

const cx = classNames.bind(styles);

// after account creation, when user taps on continue shopping, redirect user to home page
/* istanbul ignore next: breaking test case for not finding the location */
const continueShoppingClicked = () => {
    window.location.href = '/';
};

/* istanbul ignore next: breaking test case for not finding the location */
const learnMoreClicked = () => {
    window.location.href = '/rewards/rewards/dashboard/benefits';
};

const isPaymentTypeCreditCard = (paymentInfo) => {
    let isCreditCard = false;
    each(paymentInfo, (payment) => {
        /* istanbul ignore else */
        if (payment.paymentMethod === PAYMENT_METHOD_CREDIT_CARD) {
            isCreditCard = true;
        }
        return isCreditCard;
    });
    return isCreditCard;
};

export class CreateAccountPostOrder extends Component {
    static propTypes = {
        orderContactInfo: PropTypes.objectOf(PropTypes.string).isRequired,
        orderBillingInfo: PropTypes.objectOf(
            PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        ).isRequired,
        orderPaymentInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
        createAccountPostOrderData: PropTypes.objectOf(PropTypes.any).isRequired,
        actions: PropTypes.objectOf(PropTypes.objectOf).isRequired,
        context: PropTypes.objectOf(PropTypes.object).isRequired,
        renderRewards: PropTypes.bool,
        createAccountFromHeader: PropTypes.bool,
    };

    static defaultProps = {
        renderRewards: false,
        createAccountFromHeader: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            pswrdThrowEmptyError: false,
            showErrorMessage: true,
            passwordValue: '',
            expressCheckout: false,
            showExpressCheckout: false,
            phoneNumberValue:
                (this.props.orderBillingInfo && this.props.orderBillingInfo.phone) || '',
            phoneThrowEmptyError: false,
            selectedReward: 'WELCOME10',
            isMarketingOptinChecked: true,
        };
        this.createAccountSubmit = this.createAccountSubmit.bind(this);
        this.isPasswordValid = this.isPasswordValid.bind(this);
        this.handleExpressCheckout = this.handleExpressCheckout.bind(this);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { orderBillingInfo } = nextProps;
        /* istanbul ignore else */
        if (orderBillingInfo && orderBillingInfo.phone && !this.state.phoneNumberValue) {
            this.setState({
                phoneNumberValue: orderBillingInfo.phone,
            });
        }
    }

    // callback function from OptinForExpressCheckout that will give us whether user opted for express checkout or not
    handleExpressCheckout(e) {
        this.setState({
            expressCheckout: e.target.checked,
        });
    }

    // callback function from PhoneInput that will give us the value of user entered
    isPhoneValid = (validated, value) => {
        if (this.state.phoneNumberValue === value) return;
        this.setState({
            phoneNumberValue: validated && value ? value : '',
        });
    };

    // callback function from CreatePasswordInput that will give us the value of user entered password
    isPasswordValid = (validated, value) => {
        this.setState({
            passwordValue: validated && value ? value : '',
            showErrorMessage: false,
            showExpressCheckout: !isEmpty(value),
            pswrdThrowEmptyError: false,
        });
    };

    getTermsAndConditions = () => {
        const className = this.props.renderRewards
            ? `${cx('termsConditionsWrapper')} ${dt([
                  'text-gray-70',
                  'text-left',
                  'text-xsmall',
                  'mt-6',
                  '!p-0',
                  'lg:!pr-2',
              ])}`
            : `${cx('sm12', 'md12', 'lg6', 'xl6', 'termsConditionsWrapper')} ${dt([
                  'text-gray-70',
                  'text-left',
                  'text-xsmall',
                  'mt-6',
                  '!p-0',
                  'lg:!pr-2',
              ])}`;
        return (
            <div className={className}>
                <p>
                    By updating my information to create a jcp.com account, I agree to the Rewards{' '}
                    <a
                        href="https://www.jcpenney.com/m/rewards-terms-and-conditions?pageId=pg40067700009"
                        rel="noopener noreferrer"
                        target="_blank"
                        className={dt(['underline', 'text-gray-70'])}
                    >
                        {' '}
                        Terms & Conditions{' '}
                    </a>
                    and to receive email offers at the same email address above.
                </p>
            </div>
        );
    };

    enrollRewardsSubmit = (e) => {
        e.preventDefault();
        this.setState({ showErrorMessage: true });
        /* istanbul ignore else */
        if (this.state.phoneNumberValue === '') {
            this.setState({
                phoneThrowEmptyError: true,
            });
            return;
        }
        this.setState({
            phoneThrowEmptyError: false,
        });
        const payload = {
            body: {
                firstName: this.props.orderBillingInfo.firstName,
                lastName: this.props.orderBillingInfo.lastName,
                emailAddress: this.props.orderContactInfo.emailId,
                rewardsProfile: {
                    contact: {
                        phone: this.state.phoneNumberValue,
                        type: 'home',
                    },
                },
            },
        };
        this.props.actions.showGlobalLoader(true);
        this.props.actions.enrollRewardlink(payload);
    };

    handleRewardChange = (selectedReward) => {
        this.setState({ selectedReward });
    };

    // create account submit function will submit provided payload with createAccountPostOrder Action
    handleMarketingOptinChange = (isChecked) => {
        this.setState({ isMarketingOptinChecked: isChecked });
    };

    createAccountSubmit(e) {
        e.preventDefault();
        this.setState({ showErrorMessage: true });
        let check = 0;
        /* istanbul ignore else */
        if (this.state.passwordValue === '') {
            this.setState({
                pswrdThrowEmptyError: true,
            });
            check += 1;
        }
        /* istanbul ignore else */
        if (this.state.phoneNumberValue === '') {
            this.setState({
                phoneThrowEmptyError: true,
            });
            check += 1;
        }
        /* istanbul ignore else */
        if (check > 0) return;
        this.setState({
            pswrdThrowEmptyError: false,
            phoneThrowEmptyError: false,
        });
        const payload = {
            isCreateAccountPostOrder: true,
            ...(get(this.props.context, 'featureFlags.enableCreateAccountMktOptin', true) && {
                emailOptin: this.state.isMarketingOptinChecked,
            }),
            body: {
                firstName: this.props.orderBillingInfo.firstName,
                lastName: this.props.orderBillingInfo.lastName,
                emailAddress: this.props.orderContactInfo.emailId,
                password: this.state.passwordValue,
                expressCheckout: this.state.expressCheckout,
                emailSpecialOffers: true,
                welcomeCashPass: this.state.selectedReward,
                rewardsProfile: {
                    contact: {
                        phone: this.state.phoneNumberValue,
                        type: 'home',
                    },
                },
            },
        };
        this.props.actions.showGlobalLoader(true);
        this.props.actions.createAccountPostOrder(payload);
    }

    renderCreateAccountSection = (
        orderContactInfo,
        orderBillingInfo,
        paymentTypeCreditCard,
        phoneLabel,
        isMobile,
        enableInputFieldMaskFix,
        isBNPLOnOrder
    ) => (
        <div>
            <p
                data-automation-id="at-createAccount-header"
                className={`${styles.createAccountHeader} ${dt([
                    'text-2xlarge',
                    'font-open-sans-bold',
                    this.state.showErrorMessage ? 'pt-0' : 'pt-2',
                ])}`}
            >
                Save More & Earn Rewards By Creating an Account
            </p>
            <div className={`${cx('sm12', 'md12', 'col12')} ${dt(['mt-2', '!p-0'])}`}>
                <p
                    data-automation-id="at-createAccount-title"
                    className={`${styles.createAccountTitle} ${dt(['text-medium'])}`}
                >
                    {OC_ACCOUNT_CREATION_NOTE}{' '}
                    <b data-qm-block="true">{orderContactInfo.emailId}</b>
                </p>
            </div>
            <form onSubmit={this.createAccountSubmit}>
                <div
                    className={`${cx('phoneNumber', 'sm12', 'md12', 'col6', 'phoneNumberNewStyle')}
                    ${dt(['mt-6', 'smMd:!p-0', 'lg:!pl-0'])}`}
                >
                    <PhoneInputField
                        value={this.state.phoneNumberValue}
                        placeholder="Phone Number"
                        isPhoneValidated={this.isPhoneValid}
                        emptyInputError={this.state.phoneThrowEmptyError}
                        showTickIcon={false}
                        enableInputFieldMaskFix={enableInputFieldMaskFix}
                        wrapperTheme={dt(['!p-0'])}
                        phoneInputId="ocp_phone"
                        phoneInputName="ocp_phone"
                        isRegexStrict
                    />
                </div>
                <div
                    className={`${cx('createPassword', 'pwdExpressChkOut', 'sm12', 'md12', 'col6')}
                     ${dt(['relative', 'smMd:mt-5', 'lg:mt-6', 'smMd:!p-0', 'lg:!pr-0'])}`}
                >
                    <CreatePasswordInputField
                        userEmail={orderContactInfo.emailId}
                        userFirstName={orderBillingInfo.firstName}
                        userLastName={orderBillingInfo.lastName}
                        isPasswordValidated={this.isPasswordValid}
                        emptyInputError={this.state.pswrdThrowEmptyError}
                        shouldDisplayEyeIcon
                        customTheme={`${cx('noMarginBot')} ${dt(['mb-0'])}`}
                        placeholder="Create Password"
                        preferenceCreateAccount={
                            this.props.context &&
                            this.props.context.preferences &&
                            this.props.context.preferences.createAccount
                        }
                    />
                </div>
                {this.props.context?.featureFlags.enableCrossBrand && (
                    <ChooseYourReward
                        onRewardChange={this.handleRewardChange}
                        preferences={this.props.context?.preferences}
                        page="OCP"
                    />
                )}
                {paymentTypeCreditCard && this.state.showExpressCheckout && !isBNPLOnOrder ? (
                    <div
                        className={`${cx('sm12', 'md12', 'accountFooter')}
                        ${dt(['md:float-left', '!p-0'])}`}
                    >
                        <OptinForExpressCheckout
                            defaultExpressCheckout={this.state.expressCheckout}
                            handleExpressCheckout={this.handleExpressCheckout}
                        />
                    </div>
                ) : null}
                {get(this.props.context, 'featureFlags.enableCreateAccountMktOptin', true) && (
                    <div className={dt(['pt-6', 'clear-both'])}>
                        <MarketingOptin
                            preferences={this.props.context?.preferences}
                            onMarketingOptinChange={this.handleMarketingOptinChange}
                        />
                    </div>
                )}
                <div
                    className={`${cx('sm12', 'md12', 'accountFooter')}
                    ${dt(['md:float-left', '!p-0'])}`}
                >
                    {!get(this.props.context, 'featureFlags.enableCreateAccountMktOptin', true) ? (
                        this.getTermsAndConditions()
                    ) : (
                        <></>
                    )}
                    <div
                        className={`${cx(
                            'sm12',
                            'md12',
                            'col6',
                            isMobile ? 'noSidePaddingMobile' : 'buttonAlign',
                            'buttonWrapper'
                        )} ${dt([
                            '!p-0',
                            !get(
                                this.props.context,
                                'featureFlags.enableCreateAccountMktOptin',
                                true
                            ) && 'lg:!pl-2',
                            get(
                                this.props.context,
                                'featureFlags.enableCreateAccountMktOptin',
                                true
                            ) && 'lg:!w-[460px]',
                        ])}`}
                    >
                        <Button
                            type="submit"
                            automationId="at-accPO-createAccountButton"
                            buttonType="Primary"
                            size="Lg"
                            className={`${cx('createAccountButton', 'borderRadius')} ${dt([
                                'mt-6',
                                'w-full',
                            ])}`}
                            onClick={this.createAccountSubmit}
                        >
                            {CREATE_ACCOUNT}
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );

    renderRewardSection = (phoneLabel, isMobile, enableInputFieldMaskFix) => (
        <div>
            <p
                data-automation-id="at-createAccount-header"
                className={`${styles.createAccountHeader} ${dt([
                    'text-2xlarge',
                    'font-open-sans-bold',
                    this.state.showErrorMessage ? 'pt-0' : 'pt-8',
                ])}`}
            >
                Join JCP Rewards
            </p>
            <div className={`${cx('sm12', 'md12', 'col12')} ${dt(['mt-2', '!p-0'])}`}>
                <p
                    data-automation-id="at-createAccount-title"
                    className={`${styles.createAccountTitle} ${dt([
                        'sm:text-medium',
                        'lg:text-small',
                    ])}`}
                >
                    All we need is your phone number so you can start earning Rewards when you shop
                    online or in stores.
                </p>
            </div>
            <form onSubmit={this.enrollRewardsSubmit}>
                <div className={`${cx('rewardsSection')} ${dt(['md:!flex'])}`}>
                    <div
                        className={`${cx('phoneNumber', 'sm12', 'md6', 'lg6')} ${dt([
                            '!p-0',
                            'md:mr-3',
                            'mt-[14px]',
                        ])}`}
                    >
                        <PhoneInputField
                            value={this.state.phoneNumberValue}
                            placeholder="Phone Number"
                            isPhoneValidated={this.isPhoneValid}
                            emptyInputError={this.state.phoneThrowEmptyError}
                            enableInputFieldMaskFix={enableInputFieldMaskFix}
                            showTickIcon={false}
                            wrapperTheme={dt(['!p-0'])}
                            isRegexStrict
                        />
                    </div>
                    <div
                        className={`${cx(
                            'sm12',
                            'md6',
                            'lg6',
                            'buttonWrapper',
                            'enrollButtonWrapper'
                        )} ${dt(['md:ml-3', 'smOnly:!m-0', 'sm:!p-0'])}`}
                    >
                        <Button
                            type="submit"
                            automationId="at-account-enrollRewardsButton"
                            buttonType="Primary"
                            size="Lg"
                            className={`${styles.enrollRewardsButton} ${dt([
                                'w-full',
                                'smOnly:mt-6',
                                'md:mt-4',
                            ])}`}
                            onClick={this.enrollRewardsSubmit}
                        >
                            Enroll in Rewards
                        </Button>
                    </div>
                </div>
                {this.getTermsAndConditions(isMobile)}
            </form>
        </div>
    );

    renderOCPAccountSections = (
        orderContactInfo,
        orderBillingInfo,
        paymentTypeCreditCard,
        phoneLabel,
        isMobile,
        enableInputFieldMaskFix,
        isBNPLOnOrder
    ) =>
        this.props.renderRewards
            ? this.renderRewardSection(phoneLabel, isMobile, enableInputFieldMaskFix)
            : this.renderCreateAccountSection(
                  orderContactInfo,
                  orderBillingInfo,
                  paymentTypeCreditCard,
                  phoneLabel,
                  isMobile,
                  enableInputFieldMaskFix,
                  isBNPLOnOrder
              );

    render() {
        const { orderBillingInfo, orderContactInfo, orderPaymentInfo } = this.props;
        const isBNPLOnOrder = find(orderPaymentInfo, { type: BNPL_SYF }, false);
        /* istanbul ignore else */
        if (isEmpty(orderContactInfo) || isEmpty(orderBillingInfo) || isEmpty(orderPaymentInfo)) {
            return null;
        }

        const paymentTypeCreditCard = isPaymentTypeCreditCard(orderPaymentInfo);
        // once create Acc API call is made, check for error scenario
        const createAccPostOrderData =
            this.props.createAccountPostOrderData && this.props.createAccountPostOrderData.data
                ? this.props.createAccountPostOrderData.data
                : {};
        let errorMessage = createAccPostOrderData.errorMessage
            ? createAccPostOrderData.errorMessage
            : '';
        const rewardsEnrolledStatus = createAccPostOrderData.status;
        const { accountRequestStatus = '' } = createAccPostOrderData;

        // Setting Default error message when there is no error message from backend
        /* istanbul ignore else */
        if (accountRequestStatus === 'FAILED' && !errorMessage) {
            errorMessage = this.props.renderRewards
                ? "We're unable to enroll you in Rewards at this time. We apologize for the inconvenience."
                : "We're unable to create your account at this time. We apologize for the inconvenience.";
        }

        // get userAccount Id if account creation is successful
        const userAccountId = createAccPostOrderData.id ? createAccPostOrderData.id : '';
        const userEmailId = this.props.createAccountFromHeader
            ? TokenProvider.get('DP_USER_EMAIL')
            : orderContactInfo.emailId;
        const createAccountSuccessMessage = `${CREATE_ACCOUNT_SUCCESS_MESSAGE}<b>${userEmailId}</b>`;

        const phoneTooltip = (
            <div className={cx('tooltip-wrapper')}>
                <div className={cx('content')}>
                    We’ll use this number to look up, and track your Rewards when you shop in
                    JCPenney stores.
                </div>
            </div>
        );

        const phoneLabel = (
            <div>
                <span>Phone Number</span>
                <span className={dt(['float-right'])}>
                    <span
                        className={`${cx('helpText')} ${dt([
                            'italic',
                            'font-open-sans-regular',
                            'text-xs',
                            'leading-6',
                            'text-gray-40',
                        ])}`}
                    >
                        Why do we need this ?
                    </span>
                    <IconTooltip
                        message={phoneTooltip}
                        icon="information"
                        iconComponent={<Information />}
                        direction="Topright"
                        tooltipContentClass={`${cx('coIconTooltip')} ${dt([
                            'smOnly:w-[255px]',
                            'md:w-[270px]',
                            'ml-10',
                            'leading-5',
                            'text-sm',
                            'font-open-sans-regular',
                            'p-2',
                            '!text-white',
                            'bg-gray-70',
                            'rounded',
                            'after:ml-10',
                            'after:!border-t-gray-70',
                            'after:right-1.5',
                            'after:!left-auto',
                            'after:!top-[99%]',
                            'text-center',
                        ])}`}
                    />
                </span>
            </div>
        );
        const { isMobile } = this.props.context.deviceType || false;
        return (
            <div>
                <div
                    className={`${styles.createAccountWrapper} ${dt(['lg:pb-0'])}`}
                    data-automation-id="at-create-acc-wrapper"
                >
                    <div className={`${cx('accountHeader', 'col12')} ${dt(['!p-0'])}`}>
                        {/* If account creation is failed, go ahead and show error notification */}
                        {accountRequestStatus === 'FAILED' &&
                        errorMessage &&
                        this.state.showErrorMessage ? (
                            <CreateAccountMessage
                                messageCategory={CREATE_ACCOUNT_MESSAGE_CATEGOR_ERROR}
                                messageTitle={errorMessage}
                            />
                        ) : (
                            ''
                        )}
                        {/* Success Section for Account Creation */}
                        {(this.props.createAccountFromHeader ||
                            (accountRequestStatus === 'SUCCESS' &&
                                userAccountId &&
                                errorMessage === '')) && (
                            <div>
                                <CreateAccountMessage
                                    messageTitle="Account Created"
                                    message={createAccountSuccessMessage}
                                    messageCategory={CREATE_ACCOUNT_MESSAGE_CATEGOR_SUCCESS}
                                />
                                <div
                                    className={`${cx('sm12', 'md12', 'col6')} ${dt([
                                        '!p-0',
                                        'lg:ml-[34px]',
                                    ])}`}
                                >
                                    <Button
                                        automationId="at-create-account-button"
                                        className={`${cx('continueShoppingBtn')} ${dt([
                                            'mt-6',
                                            'smMd:w-full',
                                            'lg:w-[215px]',
                                        ])}`}
                                        buttonType="Primary"
                                        size="Lg"
                                        type="button"
                                        onClick={continueShoppingClicked}
                                    >
                                        {CONTINUE_SHOPPING}
                                    </Button>
                                </div>
                            </div>
                        )}
                        {/* Success Section for Reward Enrollment */}
                        {accountRequestStatus === 'SUCCESS' &&
                            !userAccountId &&
                            this.props.renderRewards &&
                            errorMessage === '' && (
                                <div>
                                    <CreateAccountMessage
                                        messageTitle="You've enrolled in JCP Rewards!"
                                        message="JCP Rewards is jam-packed with exclusive benefits!"
                                        messageCategory={CREATE_ACCOUNT_MESSAGE_CATEGOR_SUCCESS}
                                    />
                                    <div
                                        className={`${cx(
                                            'col12',
                                            'noSidePadding',
                                            'rewardsCont'
                                        )} ${dt(['!px-0', 'mt-6', 'md:!flex'])}`}
                                    >
                                        <div
                                            className={`${cx('sm12', 'md6', 'lg6')} ${dt([
                                                '!px-0',
                                                'sm:!mb-6',
                                                'md:!mr-3',
                                            ])}`}
                                        >
                                            <Button
                                                automationId="at-create-account-button"
                                                className={`${cx('learnMoreBtn')} ${dt([
                                                    'w-full',
                                                ])}`}
                                                buttonType="Primary"
                                                size="Lg"
                                                type="button"
                                                onClick={learnMoreClicked}
                                            >
                                                {LEARN_MORE}
                                            </Button>
                                        </div>
                                        <div
                                            className={`${cx('sm12', 'md6', 'lg6')} ${dt([
                                                '!px-0',
                                                'md:!ml-3',
                                            ])}`}
                                        >
                                            <Button
                                                automationId="at-create-account-button"
                                                className={`${cx(
                                                    'rewardsContinueShoppingBtn'
                                                )} ${dt(['w-full'])}`}
                                                buttonType="Secondary"
                                                size="Lg"
                                                type="button"
                                                onClick={continueShoppingClicked}
                                            >
                                                {CONTINUE_SHOPPING}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {/* Block to show Create Account/Rewards Enrollment */}
                        {!__SERVER__ &&
                            accountRequestStatus !== 'SUCCESS' &&
                            !userAccountId &&
                            !rewardsEnrolledStatus &&
                            !this.props.createAccountFromHeader &&
                            this.renderOCPAccountSections(
                                orderContactInfo,
                                orderBillingInfo,
                                paymentTypeCreditCard,
                                phoneLabel,
                                isMobile,
                                enableInputFieldMaskFix,
                                isBNPLOnOrder
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    orderBillingInfo,
    orderContactInfo,
    orderPaymentInfo,
    createAccountPostOrderData,
    context,
}) => ({
    orderBillingInfo,
    orderContactInfo,
    orderPaymentInfo,
    createAccountPostOrderData,
    context,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...actions, ...showGlobalLoaderAction }, dispatch),
});

const CreateAccountPostOrderConnected = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateAccountPostOrder);

export default CreateAccountPostOrderConnected;
